import React from 'react'

const Banner = () => {
  return (
    <section className='banner'>
        <img src='../assets/images/banner_mobile.png' alt="banner" className='banner-mobile'/>
        <img src='../assets/images/banner-image.png' alt="banner" className='banner-desktop'/>
    </section>
  )
}

export default Banner